<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>仓位管理</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新
      </el-button>
    </div>
    <!--<div class="row" :gutter="20" type="flex" align="middle" justify="start" v-if="resData">-->
    <!--<div class="status" :class="{active: origin === item.origin_id}" @click="selectOrigin(item.origin_id)" v-if="item.origin_id !== -1" v-for="item in origin_list" :key="item.origin_id">{{item.origin_name}}</div>-->
    <!--</div>-->
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="">
                  <el-select v-model="form.area" multiple placeholder="仓区">
                    <el-option
                      v-for="item in areasOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.shelf"
                    placeholder="架"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.floor"
                    placeholder="层"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.position"
                    placeholder="位"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.sku"
                    placeholder="sku"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-select
                    v-model="form.is_more_sku"
                    filterable
                    placeholder="是否多sku仓位"
                  >
                    <el-option
                      v-for="item in sku_status"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-select
                    v-model="form.is_band_many_sku"
                    filterable
                    placeholder="仓位是否多sku"
                  >
                    <el-option
                      v-for="item in band_sku_status"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.dbid"
                    placeholder="dbid"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.goods_no"
                    placeholder="商品货号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-select
                    v-model="form.is_use"
                    filterable
                    placeholder="状态"
                  >
                    <el-option
                      v-for="item in status_list"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-select
                    v-model="form.is_band"
                    filterable
                    placeholder="仓位是否已绑定商品"
                  >
                    <el-option
                      v-for="item in band_status"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-select v-model="form.cate" filterable placeholder="品类">
                    <el-option value="">全部</el-option>
                    <el-option
                      v-for="item in categoryOptions"
                      :key="item.cat_id"
                      :label="item.cat_name"
                      :value="item.cat_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <!--用户id -->
                <el-form-item label="">
                  <el-input
                    v-model="form.user_id"
                    placeholder="用户id"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <!--波次号-->
                <el-form-item label="">
                  <el-input
                    v-model="form.wave_picking_no"
                    placeholder="波次号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <!--仓位属性-->
                <el-form-item label="">
                  <el-select
                    v-model="form.space_type"
                    filterable
                    placeholder="仓位属性"
                  >
                    <el-option value="">全部</el-option>
                    <el-option
                      v-for="item in locationAttributeStatus"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-button
            style="margin-left: auto"
            type="primary"
            size="mini"
            @click="clearSelectedStockSpaces"
          >
            批量清空仓位
          </el-button>
          <el-button size="mini" @click="bandLog"> 操作日志 </el-button>
          <el-button size="mini" @click="batchEdit">批量操作</el-button>
          <el-button
            style="background: #85ce61"
            type="success"
            size="mini"
            @click="addSpaceVisible = true"
          >
            新增仓位
          </el-button>
          <el-button type="danger" size="mini" @click="setStatusOfMany(0)">
            批量禁用
          </el-button>
          <el-button type="danger" size="mini" @click="setStatusOfMany(1)">
            批量启用
          </el-button>
          <el-button type="primary" size="mini" @click="exportExcel">
            导出
          </el-button>
          <el-tooltip
            class="item"
            effect="dark"
            content="第一行表头，A列仓位，B列仓位属性，C列是否多SKU仓位（Y:是，N:否）"
            placement="top-start"
          >
            <el-upload
              style="display: inline-block; margin-left: 20px"
              :action="action"
              name="file"
              :data="{ action: 1 }"
              :on-success="importSuccess"
              :on-error="importError"
              :show-file-list="false"
              with-credentials
            >
              <el-button size="mini" type="primary">导入添加仓位</el-button>
            </el-upload>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            content="第一行表头，A列仓位，B列启用 (Y） / 禁用(N），C列商品品类，D列仓位囤货量，E列仓位SKU上限量， CDE列可不填写，若为空则默认为不限制。"
            placement="top-start"
          >
            <el-upload
              style="display: inline-block; margin-left: 20px"
              :action="updateSpaceAction"
              name="file"
              :on-success="importSuccess"
              :on-error="importError"
              :show-file-list="false"
              with-credentials
            >
              <el-button size="mini" type="primary">导入修改仓位状态</el-button>
            </el-upload>
          </el-tooltip>
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            :cell-class-name="addColor"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="right"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column label="仓位" show-overflow-tooltip align="center">
              <template #default="scope">
                <div
                  type="text"
                  @click="
                    openBarCode(
                      scope.row.area +
                        scope.row.shelf +
                        '-' +
                        scope.row.floor +
                        '-' +
                        scope.row.position
                    )
                  "
                >
                  {{ scope.row.area }}{{ scope.row.shelf }}-{{
                    scope.row.floor
                  }}-{{ scope.row.position }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="sku"
              label="sku编号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="sku_num"
              label="仓位sku数量"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="num"
              label="商品总数"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="box_no"
              label="容器号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="dbids"
              label="商品明细"
              show-overflow-tooltip
              width="300"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="user_id"
              label="用户 id"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="wave_picking_no"
              label="波次号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="shipping_space_is_more_sku"
              label="是否多sku仓位"
              show-overflow-tooltip
              width="300"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="space_type_str"
              label="仓位属性"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="update_time"
              label="仓位绑定时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="shipping_space_is_use"
              label="状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="cat_names"
              label="品类"
            ></el-table-column>
            <el-table-column align="center" label="囤货量/件" prop="max">
            </el-table-column>
            <el-table-column label="操作" width="200" align="center">
              <template #default="scope">
                <el-button type="text" @click="beforeBand(scope.row)">
                  编辑
                </el-button>
                <el-button
                  size="small"
                  :type="scope.row.is_use == 1 ? 'success' : 'danger'"
                  @click="setStatus(scope.row)"
                  >{{ scope.row.is_use == 1 ? "已启用" : "已禁用" }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-dialog
          title="编辑"
          :visible.sync="bandVisible"
          width="20%"
          center
          @closed="handleDialogClosed"
        >
          <el-form :model="form" label-width="120px">
            <el-form-item label="仓位">
              <span>{{ space }}</span>
            </el-form-item>
            <el-form-item label="商品品类">
              <el-select
                v-model="form.band_cate"
                filterable
                multiple
                placeholder="商品品类"
                :disabled="form.space_type === STORAGE_TYPE.STORAGE"
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.cat_id"
                  :label="item.cat_name"
                  :value="item.cat_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="仓位囤货量">
              <el-input
                v-model.number="form.band_max"
                placeholder="仓位囤货量"
                style="width: 190px"
                type="number"
                :controls="false"
                min="0"
                :disabled="form.space_type === STORAGE_TYPE.STORAGE"
                on-keypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
              />
            </el-form-item>
            <el-form-item label="是否多sku仓位">
              <el-checkbox
                v-model="form.edit_is_more_sku"
                true-label="1"
                false-label="0"
                :disabled="form.space_type === STORAGE_TYPE.STORAGE"
                @change="onCheckboxChange"
              ></el-checkbox>
              <el-input
                v-model.number="form.max_sku_num"
                placeholder="SKU数量上限"
                style="width: 120px; margin-left: 16px"
                type="number"
                :controls="false"
                :disabled="form.edit_is_more_sku === '0'"
                min="0"
                @keydown.native="validateSKUInput"
              />
            </el-form-item>
            <el-form-item label="仓位属性">
              <el-select
                v-model="form.space_type"
                placeholder="仓位属性"
                :disabled="hasGoods"
              >
                <el-option
                  v-for="item in locationAttributeStatus"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="bandVisible = false">取 消</el-button>
            <el-button type="primary" @click="batchEditSave">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 批量操作-编辑弹框-->
        <el-dialog
          title="编辑"
          :visible.sync="batchEditDialogVisible"
          width="30%"
          center
          @closed="handleDialogClosed"
        >
          <el-form :model="form">
            <el-form-item label="仓位属性">
              <el-select
                v-model="form.space_type"
                placeholder="仓位属性"
                :disabled="hasGoods"
              >
                <el-option
                  v-for="item in locationAttributeStatus"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商品品类">
              <el-select
                v-model="form.band_cate"
                filterable
                multiple
                placeholder="商品品类"
                :disabled="form.space_type === STORAGE_TYPE.STORAGE"
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.cat_id"
                  :label="item.cat_name"
                  :value="item.cat_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="仓位囤货量">
              <el-input
                v-model.number="form.band_max"
                placeholder="仓位囤货量"
                style="width: 190px"
                type="number"
                :controls="false"
                min="0"
                :disabled="form.space_type === STORAGE_TYPE.STORAGE"
                on-keypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
              />
            </el-form-item>
            <el-form-item label="是否多sku仓位">
              <el-checkbox
                v-model="form.edit_is_more_sku"
                true-label="1"
                false-label="0"
                :disabled="form.space_type === STORAGE_TYPE.STORAGE"
                @change="onCheckboxChange"
              ></el-checkbox>
              <el-input
                v-model.number="form.max_sku_num"
                placeholder="SKU数量上限"
                style="width: 120px; margin-left: 16px"
                type="number"
                :controls="false"
                :disabled="form.edit_is_more_sku === '0'"
                min="0"
                @keydown.native="validateSKUInput"
              />
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="batchEditDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="batchEditSave">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog
          title="添加仓位"
          :visible.sync="addSpaceVisible"
          width="30%"
          center
          :close-on-click-modal="false"
        >
          <el-form :model="addForm" label-position="right" label-width="70px">
            <el-form-item label="仓区：" prop="is_strength">
              <el-select
                v-model="addForm.area"
                placeholder="仓区"
                style="width: 70%; float: left"
              >
                <el-option
                  v-for="item in areasOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="通道：">
              <el-input
                v-model="addForm.shelf"
                placeholder="1~999"
                style="width: 70%; float: left"
              ></el-input>
            </el-form-item>

            <el-form-item label="货架组：">
              <el-input
                v-model="addForm.floor"
                placeholder="1~99"
                style="width: 70%; float: left"
              ></el-input>
            </el-form-item>

            <el-form-item label="列：">
              <el-input
                v-model="addForm.col"
                placeholder="1~9"
                style="width: 70%; float: left"
              ></el-input>
            </el-form-item>

            <el-form-item label="层：">
              <el-input
                v-model="addForm.row"
                placeholder="1~9"
                style="width: 70%; float: left"
              ></el-input>
            </el-form-item>
            <el-form-item label="仓位属性">
              <el-select
                v-model="addForm.space_type"
                placeholder="仓位属性"
                :disabled="hasGoods"
              >
                <el-option
                  v-for="item in locationAttributeStatus"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="addSpaceVisible = false">取 消</el-button>
            <el-button type="primary" @click="addSpace">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="操作日志" :visible.sync="logVisible">
          <el-table
            v-if="logInfo"
            ref="multipleTable"
            v-loading="tableLoading"
            height="300"
            :data="logInfo.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column prop="operator_name" label="操作人">
              <template #default="scope">
                <span>{{
                  scope.row.operator_name == 0 ? "" : scope.row.operator_name
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="action_ext"
              label="仓位"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="action_content"
              label="操作内容"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_date"
              label="操作时间"
            ></el-table-column>
          </el-table>

          <el-pagination
            :current-page.sync="logcurPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="logInfo.page"
            :page-size="20"
            @current-change="handleCurrentChange2"
          ></el-pagination>
        </el-dialog>

        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[50, 100, 200, 500, 1000]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Global_ from "../../components/Global.vue";
import apiBaseURL from "@/utils/baseUrl.js";
import * as shippingSpaceApi from "@/openapi/erp/shippingSpace.js";
import { postClearStockSpaceData } from "@/openapi/erp/shippingSpace.js";

const STORAGE_TYPE = {
  GOODS: "1",
  STORAGE: "2",
};
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getOptionsForSpaceList();
      vm.fetchData();
    });
  },
  data() {
    return {
      categoryOptions: [], // 品类选项
      areasOptions: [], // 仓区选项
      STORAGE_TYPE,
      hasGoods: false, // 判断货架上是否有商品
      logVisible: false,
      resData: {},
      form: {
        clear_area: [],
        band_cate: [],
        band_min_max: 0,
        pagesize: 50,
        is_excel: 0,
        edit_is_more_sku: "0",
        band_max: "0",
        max_sku_num: 1,
        space_type: "1",
        user_id: "",
        wave_picking_no: "",
      },
      origin_list: [
        {
          origin_id: 1,
          origin_name: "广州",
        },
        {
          origin_id: 2,
          origin_name: "杭州",
        },
      ],
      origin: 1,
      space: "",
      ss_id: 0,
      loading: false,
      tableLoading: false,
      url: "/erp/ShippingSpace/spaceList",
      curPage: 1,
      filterFold: false,
      isAll: false,
      supplyData: null,
      bandVisible: false,
      status_list: [
        { key: "", value: "全部" },
        { key: 0, value: "禁用" },
        { key: 1, value: "启用" },
      ],
      band_status: [
        { key: "", value: "全部" },
        { key: 0, value: "否" },
        { key: 1, value: "是" },
        { key: 3, value: "已绑定商品且囤货未满" },
        { key: 4, value: "已绑定商品且囤货已满" },
      ],
      sku_status: [
        { key: "", value: "全部" },
        { key: 0, value: "否" },
        { key: 1, value: "是" },
      ],
      band_sku_status: [
        { key: "", value: "全部" },
        { key: 0, value: "否" },
        { key: 1, value: "是" },
      ],
      locationAttributeStatus: [
        { key: STORAGE_TYPE.STORAGE, value: "囤货仓位" },
        { key: STORAGE_TYPE.GOODS, value: "商品仓位" },
      ],
      logcurPage: 1,
      logInfo: {},
      addSpaceVisible: false,
      batchEditDialogVisible: false,
      addForm: {
        space_type: STORAGE_TYPE.GOODS,
        area: "", // 仓区
        shelf: "", // 通道
        floor: "", // 货架组
        col: "", // 列
        row: "", // 层
      },
      action: `${apiBaseURL}/erp/ShippingSpace/batchImportAddSpace`,
      updateSpaceAction: `${apiBaseURL}/erp/ShippingSpace/batchImportUpdateSpace`,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    getOptionsForSpaceList() {
      shippingSpaceApi.getOptionsForSpaceList().then((res) => {
        const { areas = [], category = [], origin = "" } = res;
        this.areasOptions = areas;
        this.categoryOptions = category;
        this.origin = parseInt(origin, 10);
      });
    },
    openBarCode(text) {
      if (Global_.environment === 0) {
        this.$alert(
          `<img src="https://erp.yishouapp.com/barcode.php?text=${text}" />`,
          "",
          {
            dangerouslyUseHTMLString: true,
            showConfirmButton: false,
            closeOnClickModal: true,
            center: true,
          }
        );
      }
    },
    selectOrigin(origin_id) {
      this.origin = origin_id;
      this.form.origin = origin_id;
      // if(this.origin != origin_id){
      //     this.$message.error('没有权限');
      // }
    },
    addColor({ row, column, columnIndex }) {
      // if (columnIndex === 15) {
      //     return 'blue-cell';
      // }
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    exportExcel() {
      // this.loading = true;
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      for (const key in val) {
        multipleSelection[key] = val[key].ss_id;
      }
      this.form.multipleSelection = multipleSelection;
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSizeChange(val) {
      this.form.pagesize = val;
      this.fetchData(true);
    },
    // 切换页码
    handleCurrentChange2(val) {
      // this.tableLoading = true;
      this.logcurPage = val;
      this.$http.get(`/erp/ShippingSpace/bandLog/page/${val}`).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.logInfo = res.data.data;
        }
      });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    un_band(row) {
      this.$confirm("确定解绑商品并清空仓位", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
        type: "warning",
      }).then(() => {
        this.$http
          .post("/erp/ShippingSpace/unBand", {
            ss_id: row.ss_id,
            goods_no: row.goods_no,
          })
          .then((res) => {
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success(res.data.msg);
              this.fetchData(true);
            }
          });
      });
    },
    beforeBand(row) {
      if (row.is_use == 0) {
        this.$message.error("此仓位已禁用，不能绑定。");
      } else {
        this.$http
          .post("/erp/ShippingSpace/beforeEdit", { ss_id: row.ss_id })
          .then((res) => {
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.space = `${
                row.area + row.shelf.toString()
              }-${row.floor.toString()}-${row.position.toString()}`;
              this.form.ss_id = row.ss_id;
              this.form.add_goods_no = res.data.data.goods_no;
              this.form.band_cate = res.data.data.cate;
              this.form.edit_is_more_sku = res.data.data.is_more_sku;
              this.form.band_min_max = res.data.data.max;
              this.form.band_max = res.data.data.max;
              this.form.space_type = res.data.data.space_type;
              this.form.max_sku_num = parseInt(res.data.data.max_sku_num, 10);
              this.hasGoods = !!row.dbids;
              this.bandVisible = true;
            }
          });
      }
    },
    batchEdit() {
      console.log(this.form);
      this.form.ss_ids = this.form.multipleSelection;
      console.log("multipleSelection", this.form.multipleSelection);
      this.form.band_cate = [];
      this.form.band_min_max = "0";
      this.form.edit_is_more_sku = "0";
      // 判断选中的仓位是否有商品
      this.hasGoods = this.resData.list.some((item) => {
        return (
          !!item.dbids &&
          this.form.multipleSelection &&
          this.form.multipleSelection.includes(item.ss_id)
        );
      });
      console.log("hasGoods", this.hasGoods);
      this.batchEditDialogVisible = true;
    },
    batchEditSave() {
      if (
        this.filteredForm.max_sku_num === 1 &&
        this.filteredForm.edit_is_more_sku === "1"
      ) {
        this.$message.error("请填写SKU数量上限");
        return;
      }
      this.$http
        .post("/erp/ShippingSpace/band", this.filteredForm)
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$message.success(res.data.msg);
            this.fetchData(true);
            this.bandVisible = false;
            this.batchEditDialogVisible = false;
            this.space = "";
            this.ss_id = 0;
            this.form.ss_id = "";
            this.form.band_cate = [];
            this.form.band_min_max = "";
            this.form.add_goods_no = "";
            this.form.ss_ids = [];
          }
        });
    },
    bandLog() {
      this.$http.get("/erp/ShippingSpace/bandLog").then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.logInfo = res.data.data;
          this.logVisible = true;
        }
      });
    },
    setStatusOfMany(is_use) {
      let str = "";
      if (is_use == 0) {
        str = "禁用";
      } else {
        str = "启用";
      }
      this.$confirm(`确定批量${str}仓位`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
        type: "warning",
      }).then(() => {
        this.$http
          .post("/erp/ShippingSpace/setStatusOfMany", {
            is_use,
            ids: this.form.multipleSelection,
          })
          .then((res) => {
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success(res.data.msg);
              this.fetchData(true);
            }
          });
      });
    },
    addSpace() {
      console.log("x", this.addForm);
      this.$http.post("/erp/ShippingSpace/add", this.addForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.e(res.data.msg);
        } else {
          this.form.is_excel = 0;
          this.$message.success(res.data.msg);
          this.fetchData();
          this.addSpaceVisible = false;
        }
      });
    },
    setStatus(row) {
      let str = "";
      let is_use = 0;
      if (row.is_use == 1) {
        str = "禁用";
        is_use = 0;
      } else {
        str = "启用";
        is_use = 1;
      }
      this.$confirm(`确定${str}仓位`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
        type: "warning",
      }).then(() => {
        this.$http
          .post("/erp/ShippingSpace/setStatus", {
            ss_id: row.ss_id,
            is_use,
          })
          .then((res) => {
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success(res.data.msg);
              this.fetchData(true);
            }
          });
      });
    },
    trim(str, is_global) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },

    // 批量添加仓位成功
    importSuccess(rs) {
      // console.log(rs);
      if (rs.code != 200) {
        return this.$message.e(rs.msg);
      }
      this.$message.success(rs.msg);
      if (rs.data.file) {
        window.open(apiBaseURL + rs.data.file);
      }
      this.fetchData(true);
    },
    // 批量添加仓位失败
    importError() {
      this.$message.e("导入文件出错");
    },
    onCheckboxChange() {
      if (this.form.edit_is_more_sku === "0") {
        this.form.max_sku_num = 1; // set default value to 1 when checkbox is unchecked
      }
    },
    validateSKUInput(event) {
      // const keyCode = event.keyCode || event.which;
      // const char = String.fromCharCode(keyCode);
      // console.log("🚀 : validateSKUInput : char:", char);

      // // Allow only digits and the backspace key
      // if (!/[\d]/.test(char) && keyCode !== 8) {
      //   event.preventDefault();
      // }
      const { key } = event;
      console.log("🚀 : validateSKUInput : key:", key);

      // Allow only digits and the backspace key
      if (!/[\d]/.test(key) && key !== "Backspace") {
        event.preventDefault();
      }
    },
    resetForm() {
      this.form = this.$options.data().form;
    },
    handleDialogClosed() {
      this.resetForm();
    },
    // 批量清空仓位
    clearSelectedStockSpaces() {
      const { multipleSelection } = this.form;
      if (!multipleSelection || multipleSelection.length === 0) {
        this.$message.warning("请先选择需要批量操作的仓位");
        return;
      }
      this.$confirm(`是否清空当前全部囤货仓位所绑定的商品数据？`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
        type: "warning",
      }).then(() => {
        this.loading = true;
        postClearStockSpaceData({ ss_ids: this.form.multipleSelection })
          .then(() => {
            this.$message.success("批量清空仓位操作成功！");
            this.fetchData(true);
          })
          .catch(this.$noop)
          .finally(() => {
            this.loading = false;
          });
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/space/SpaceList.vue